import { ThemeSSRManager } from '../src/ThemeSSRManager.ts';

export const themeSSRManager = new ThemeSSRManager();
